import styled from "styled-components";

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 24px;
  overflow: hidden;
`;

export const NameCell = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
